import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CoreActions } from '@next/core-lib';
import { LocaleService } from '@next/core-lib/i18n';
import { NotificationActions } from '@next/core-lib/notification';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map, mergeMap, startWith } from 'rxjs/operators';

import { LabresultModuleState } from '../../models/labresult.model';
import { LabresultService } from '../../services/labresult.service';

import * as labresultActions from '../actions/labresult.actions';

@Injectable()
export class LabresultEffects {
  getLabresults$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(labresultActions.getLabresults),
      mergeMap(({ keyword, currentPage, currentPageSize, sort }) =>
        this.labresultService.getLabResults(keyword, currentPage, currentPageSize, sort).pipe(
          map((labresults) =>
            labresultActions.getLabresultsSuccess({
              labresults: labresults.labResults,
              pagination: labresults.pagination,
            }),
          ),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 404) {
              return of(
                NotificationActions.errorSnackbar({
                  message: this.locale.translate('labResults_searchNotFound'),
                }),
                labresultActions.labresultNotFound(),
              );
            } else {
              return of(
                NotificationActions.errorSnackbar({
                  message: this.locale.translate('labResults_searchError'),
                }),
              );
            }
          }),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => {
            labresultActions.clearLabresultResult();
            return this.store.dispatch(CoreActions.setLoading({ loading: false }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly labresultService: LabresultService,
    private store: Store<LabresultModuleState>,
    private locale: LocaleService,
  ) {}
}
